import { API_JWT_BASE_URL } from '../http'

export const SEARCH_SFES_API = `${API_JWT_BASE_URL}/SFEManagement/search`
export const IMPORT_ASSET_KEYS_API = `${API_JWT_BASE_URL}/Assets/sfe/import`
export const EXPORT_SFES_API = `${API_JWT_BASE_URL}/SFEManagement/Export`
export const GET_SFE_KEY_COLUMNS_API = `${API_JWT_BASE_URL}/SFEManagement/GetSFEKeyColumns`

export const SFES_QUERY_KEYS = {
  SEARCH_SFES: 'SEARCH_SFES',
  EXPORT_SFES: 'EXPORT_SFES',
  IMPORT_ASSET_KEYS: 'IMPORT_ASSET_KEYS',
  GET_SFE_KEY_COLUMNS: 'GET_SFE_KEY_COLUMNS'
}
